var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08856 6.64248L15.2761 0.454975C15.3914 0.335587 15.5293 0.240359 15.6818 0.174848C15.8343 0.109337 15.9983 0.0748537 16.1643 0.0734115C16.3303 0.0719692 16.4949 0.103596 16.6485 0.166447C16.8021 0.229299 16.9417 0.322115 17.0591 0.439481C17.1764 0.556847 17.2692 0.696412 17.3321 0.850032C17.3949 1.00365 17.4266 1.16825 17.4251 1.33423C17.4237 1.5002 17.3892 1.66423 17.3237 1.81673C17.2582 1.96924 17.163 2.10717 17.0436 2.22247L9.97231 9.29373C9.7379 9.52806 9.42002 9.65971 9.08856 9.65971C8.75711 9.65971 8.43922 9.52806 8.20481 9.29373L1.13356 2.22247C1.01418 2.10717 0.918948 1.96924 0.853437 1.81673C0.787925 1.66423 0.753443 1.5002 0.752 1.33423C0.750558 1.16825 0.782185 1.00365 0.845036 0.850032C0.907887 0.696412 1.0007 0.556847 1.11807 0.439481C1.23544 0.322115 1.375 0.229299 1.52862 0.166447C1.68224 0.103596 1.84684 0.0719692 2.01281 0.0734115C2.17879 0.0748537 2.34281 0.109337 2.49532 0.174848C2.64782 0.240359 2.78576 0.335587 2.90106 0.454975L9.08856 6.64248Z",
    fill: "#000306"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowDown);
export default __webpack_public_path__ + "static/media/row-down.a3d372f0.svg";
export { ForwardRef as ReactComponent };